import ProdoqRole from '../../../components/units/Prodoq/Role';

export default function ProdoqRolePage() {
  return <ProdoqRole />;
}
